<template>
  <div class="ruler ruler-v" :style="style">
    <div class="scale" :style="`height: ${scaleHeight}px; transform:translateY(${move}px)`">
      <div
        class="mm"
        v-for="mm in Math.ceil(length * 10)"
        :key="mm"
        :style="niddleStyle(mm)"
      >
        <span v-if="(mm - 1) % 10 === 0" class="num">{{ (mm - 1) / 10 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: Number,
    height: Number,
    length: Number, // 对应的实际尺寸 厘米
    scaleHeight: Number,
    move: Number
  },
  computed: {
    style() {
      return `width: ${this.width}px; height: ${this.height}px;transform: translateY(${this.width}px)`
    },
    // 厘米
    cm() {
      let arr = new Array(Math.ceil(this.length))
      for (var i = 0; i < arr.length; i++) arr[i] = i
      return arr
    },
    mm2px() {
      return Math.floor((this.scaleHeight / (this.length * 10)) * 100) / 100
    }
  },
  methods: {
    niddleStyle(index) {
      const height =
        (index - 1) % 10 === 0 ? 24 : (index - 1) % 5 === 0 ? 18 : 7
      return {
        height: `${this.mm2px}px`,
        width: `${height}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ruler-v {
  pointer-events: none;
  .scale {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    left: 0;
    top: 0;
    // overflow: hidden;
    .mm {
      border-top: 1px solid #000;
      box-sizing: border-box;
      position: relative;
      .num {
        position: absolute;
        right: -4px;
        top: 0px;
        font-size: 12px;
      }
    }
  }
}
</style>
